import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { UserClientService } from "@rightship-tech/common-ui/services/basic/user-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { SubscriptionProductCodes } from "../../../../../models/customers/customer-subscription.models";
@autoinject
export class SubscriptionHelper {

    constructor(private userClientService: UserClientService, private configService: ConfigService) {
    }

    getCustomerType(): string {
        const customerType = this.userClientService.currentUser?.businessUnit?.customerType;

        return customerType;
    }

    getUpgradeSubscriptionUrl(productCode: string = null): string {
        const customerType = this.getCustomerType();
        let rightStoreUri: string = this.configService.config.urls.rightStoreUrl;
        const env = this.configService.config.environment || "development";
        const qSplit = rightStoreUri.split("?");
        let queryParams = qSplit?.length > 1? qSplit[1]: `env=${env}`;
        rightStoreUri = qSplit?.length > 1? qSplit[0]: rightStoreUri;
        const shipManagerTypes = ["ship owner", "ship manager"];
        if(env.toLowerCase() == "production")
            queryParams = null;
        const url = rightStoreUri + (rightStoreUri.endsWith("/")? "": "/")
            + (productCode == SubscriptionProductCodes.pscRiskIqInApp
                ? `Catalog/products/${SubscriptionProductCodes.pscRiskIq}`
                : shipManagerTypes.indexOf(customerType?.toLowerCase()) > -1
                ? "Catalog/products/digital-subscription-vessel-custom"
                : "Product/rightship-subscription")
            + (queryParams ? "?" + queryParams: "");
        
        return url;
    }
}